import React from 'react';
import { SectionHeader } from '../../../ui/molecules/SectionHeader';
import type { WorkStat } from '../resume.types';

type WorkSectionProps = {
  workStats: WorkStat[];
};

export function WorkSection({ workStats }: WorkSectionProps) {
  return (
    <section
      id="work"
      className="px-4 py-16 bg-white dark:bg-stone-900"
      aria-labelledby="work-heading"
    >
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          id="work-heading"
          title="My Remarkable Works"
          subtitle="Apps delivered and experience"
        />
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          {workStats.map((stat, i) => (
            <div
              key={stat.label}
              className="rounded-xl border border-stone-200/80 bg-emerald-50/50 px-4 py-6 text-center opacity-0 animate-fade-in-up dark:border-stone-600 dark:bg-emerald-900/20"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <span className="font-display text-3xl font-bold text-emerald-700 dark:text-emerald-400 md:text-4xl">
                {stat.value}
              </span>
              <span className="mt-1 block text-sm font-medium text-stone-600 dark:text-stone-400">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
